<template>
  <header class="header main-background secondary-text mobile-visible"
      :class="{ 'navbar--hidden': !showHeader }"
      role="presentation">
    <slot name="back-button">
      <button class="back-btn secondary-text" @click="goBack">&lt;&nbsp;{{ $t("button.back") }}</button>
    </slot>
    <slot></slot>
    <nav role="navigation">
      <div class="menu-toggle">
        <input ref="menuSwitch" type="checkbox" />
        <span class="secondary-background"></span>
        <span class="secondary-background"></span>
        <span class="secondary-background"></span>
        <navbar :languageDropdownOpen="true" @change="onLanguageChange()"/>
      </div>
    </nav>
  </header>
</template>

<script>
import HeaderNavbar from '@/components/HeaderNavbar'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'Header',
  components: {
    'navbar': HeaderNavbar
  },
  data () {
    return {
      showHeader: true,
      lastScrollPosition: 0
    }
  },
  methods: {
    ...mapMutations('history', [
      'popEntry'
    ]),
    goBack () {
      this.popEntry()
      const whereTo = this.lastEntry

      if (whereTo) {
        this.popEntry()

        this.$router.push({ name: whereTo.name, params: whereTo.params, query: whereTo.query })
      } else {
        this.$router.push({ name: 'Home' })
      }
    },
    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
        return
      }
      this.showHeader = currentScrollPosition < this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    },
    onLanguageChange () {
      this.$refs.menuSwitch.checked = false
    }
  },
  computed: {
    ...mapGetters('history', [
      'lastEntry'
    ])
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>
